import _userAgent from './useragent';

export default class ViewerDownloader {
    constructor(viewer, downloadButtonId, typeSelectorName, dummyAnchorId, pageSelectorName, pageInputId) {
        this._viewer = viewer;
        //this._baseUrl = baseUrl;

        this._typeSelectors = document.querySelectorAll('input[name=' + typeSelectorName + ']');

        if (pageSelectorName !== undefined && pageSelectorName !== null && pageSelectorName !== '') {
            this._pageSelectors = document.querySelectorAll('input[name=' + pageSelectorName + ']');
            this._pageInput = document.getElementById(pageInputId);
            this._initPageSelector();
        }

        if (this._pageInput) this._pageInput.addEventListener('change', this._parsePageEvent.bind(this), false);

        //this._lastPage = this._viewer.totalPagesCount;

        this._alertMsg = document.getElementById('alert-msg');
        if (this._alertMsg) this._alertMsg.textContent = '';

        this._dummyElement = document.getElementById(dummyAnchorId);
        document.getElementById(downloadButtonId).addEventListener('click', this._download.bind(this), false);
    }

    /**
 * サブミットイベントのイベントハンドラ。
 * 実際にはフォームに送信せずに
 * @param {MouseEvent} event マウスイベント。
 */
    _download(event) {
        
        try {
            if (_userAgent !== 'ie') {
                this._dummyElement.setAttribute('href', this._generateUrl());
                if (this._getDownloadFileType() === 'JPEG') {
                    this._dummyElement.setAttribute('download', 'download.jpg');
                }
                else {
                    this._dummyElement.setAttribute('download', 'download.jp2');
                }
                this._dummyElement.click();
            }
            else {
                var xhr = new XMLHttpRequest();
                xhr.open('GET', this._generateUrl(), true);
                xhr.responseType = 'blob';
                xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                xhr.onload = function (e) {
                    if (xhr.status === 200) {
                        var fileName = decodeURI(xhr.getResponseHeader('Content-Disposition').replace('attachment; filename=', ''));
                        window.navigator.msSaveBlob(xhr.response, fileName);
                    }
                    else {
                        var reader = new FileReader();
                        reader.addEventListener('loadend', function () {
                            alert(reader.result);
                        });
                        reader.readAsBinaryString(xhr.response);
                    }
                    this._dummyElement.click();
                };

                xhr.onerror = function(e) {
                    var reader = new FileReader();
                    reader.addEventListener('loadend', function () {
                        alert(reader.result);
                    });
                    reader.readAsBinaryString(xhr.response);
                    this._dummyElement.click();
                };
                xhr.send();
            }

            this._alertMsg.textContent = '';
        }
        catch (e) {
            //this._alertMsg.textContent = e.message;
            console.log(e.message);
        }
    }

    /**
     * ダウンロードする画像の種別を取得します。
     * @returns {String} ダウンロードする画像の種別。
     */
    _getDownloadFileType() {
        let fileType = '';
        for (let i = 0; i < this._typeSelectorsCount; i = i + 1) {
            if (this._typeSelectors[i].checked) {
                fileType = this._typeSelectors[i].value;
                return;
            }
        }

        return fileType;
    }

    /**
     * ダウンロードする画像の種別を取得します。
     * @returns {String} ダウンロードする画像の種別。
     */
    _getDownloadFileType() {
        

        let fileType = 'JPEG';
        const selectorsLength = this._typeSelectors.length;
        for (let i = 0; i < selectorsLength; i = i + 1) {
            if (this._typeSelectors[i].checked) return this._typeSelectors[i].value;
        }

        return fileType;
    }

    /**
     * ページ種別セレクターの初期化を行う。
     */
    _initPageSelector() {
        
        const selectorsCount = this._pageSelectors.length;
        for (let i = 0; i < selectorsCount; i = i + 1) {
            let selector = this._pageSelectors[i];
            if (selector.value === 'current-page') {
                selector.addEventListener('change', function () {
                    this._pageInput.disabled = true;
                }.bind(this));
            }
            else if (selector.value === 'page-select') {
                this._pageInput.disabled = selector.checked === false;
                selector.addEventListener('change', function () {
                    this._pageInput.disabled = false;
                }.bind(this));
            }
        }
    }

    _parsePageEvent(event) {
       
        try {
            this._parsePage(event.currentTarget.value);
            this._alertMsg.textContent = '';
        }
        catch (e) {
            this._alertMsg.textContent = e.message;
        }
    }

    /**
     * ダウンロードするURLを生成します。
     * @returns {String} ダウンロード先のURL。
     */
    _generateUrl() {
       
        let url = this._viewer.world.getItemAt(0).source['@id'];
        const fileType = this._getDownloadFileType();

        if (fileType === "JPEG") {
            url += "/full/full/0/default.jpg";
        }
        else {
            url = url.replace('images', 'contents')
        }

        return url;
    }
}